import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import {
    ITransitionEffect,
    coverBottom, coverLeft, coverLeftDown, coverLeftUp,
    coverRight, coverRightDown, coverRightUp, coverTop,
    cutBlack, cutNone, fadeBlack, fadeSmooth,
    flipLeft, flipRight, galleryLeft, galleryRight,
    prismBottom, prismLeft, prismRight, prismTop,
    pullBottom, pullLeft, pullLeftDown, pullLeftUp,
    pullRight, pullRightDown, pullRightUp, pullTop,
    pushBottom, pushLeft, pushRight, pushTop,
    switchLeft, switchRight, warpEnlarge, warpNarrow, newsflash,
} from '@framework/workbench/ui/transition/transition-effect-option/transition-effect-list';
import * as icon from '@framework/workbench/ui/transition/transition-icon';
import {
    EightDirectionType,
    InOutDirectionType,
    SideDirectionType,
    SwitchDirectionType,
} from '@src/slide/domain/ui-model/element-modeles/transition/direction/constants';

export const TRULY_SYMBOL = 'true';
export const FALSY_SYMBOL = 'false';

export const transitionEffectMapping: Partial<Record<TransitionType, {
    disable?: boolean;
    icon?: string;
    bool?: boolean
    conditionKey?: string;
    conditions?: { [key: string]: ITransitionEffect }
    data?: ITransitionEffect;
}>> = {
    [TransitionType.EMPTY]: {
        disable: true,
        icon: icon.NO_EFFECT_ICON,
    },
    [TransitionType.FLASH]: {
        disable: true,
        icon: icon.FLASH_ICON,
    },
    [TransitionType.FADE]: {
        bool: true,
        conditionKey: 'throughBlack',
        conditions: {
            [FALSY_SYMBOL]: fadeSmooth,
            [TRULY_SYMBOL]: fadeBlack,
        },
    },
    [TransitionType.PUSH]: {
        conditionKey: 'direction.direction',
        conditions: {
            [SideDirectionType.LEFT]: pushLeft,
            [SideDirectionType.UP]: pushTop,
            [SideDirectionType.RIGHT]: pushRight,
            [SideDirectionType.DOWN]: pushBottom,
        },
    },
    [TransitionType.SWITCH]: {
        conditionKey: 'direction.direction',
        conditions: {
            [SwitchDirectionType.RIGHT]: switchRight,
            [SwitchDirectionType.LEFT]: switchLeft,
        },
    },
    [TransitionType.CUT]: {
        bool: true,
        conditionKey: 'throughBlack',
        conditions: {
            [FALSY_SYMBOL]: cutNone,
            [TRULY_SYMBOL]: cutBlack,
        },
    },
    [TransitionType.PULL]: {
        conditionKey: 'direction.direction',
        conditions: {
            [EightDirectionType.RIGHT]: pullRight,
            [EightDirectionType.LEFT]: pullLeft,
            [EightDirectionType.UP]: pullTop,
            [EightDirectionType.DOWN]: pullBottom,
            [EightDirectionType.RIGHT_UP]: pullRightUp,
            [EightDirectionType.RIGHT_DOWN]: pullRightDown,
            [EightDirectionType.LEFT_UP]: pullLeftUp,
            [EightDirectionType.LEFT_DOWN]: pullLeftDown,
        },
    },
    [TransitionType.COVER]: {
        conditionKey: 'direction.direction',
        conditions: {
            [EightDirectionType.RIGHT]: coverRight,
            [EightDirectionType.LEFT]: coverLeft,
            [EightDirectionType.UP]: coverTop,
            [EightDirectionType.DOWN]: coverBottom,
            [EightDirectionType.RIGHT_UP]: coverRightUp,
            [EightDirectionType.RIGHT_DOWN]: coverRightDown,
            [EightDirectionType.LEFT_UP]: coverLeftUp,
            [EightDirectionType.LEFT_DOWN]: coverLeftDown,
        },
    },
    [TransitionType.WARP]: {
        conditionKey: 'direction.direction',
        conditions: {
            [InOutDirectionType.IN]: warpEnlarge,
            [InOutDirectionType.OUT]: warpNarrow,
        },
    },
    [TransitionType.NEWSFLASH]: {
        icon: icon.NEWSFLASH_ICON,
        data: newsflash,
    },
    [TransitionType.FLIP]: {
        conditionKey: 'direction.direction',
        conditions: {
            [SwitchDirectionType.RIGHT]: flipRight,
            [SwitchDirectionType.LEFT]: flipLeft,
        },
    },
    [TransitionType.GALLERY]: {
        conditionKey: 'direction.direction',
        conditions: {
            [SwitchDirectionType.RIGHT]: galleryRight,
            [SwitchDirectionType.LEFT]: galleryLeft,
        },
    },
    [TransitionType.PRISM]: {
        conditionKey: 'direction.direction',
        conditions: {
            [SideDirectionType.LEFT]: prismLeft,
            [SideDirectionType.UP]: prismTop,
            [SideDirectionType.RIGHT]: prismRight,
            [SideDirectionType.DOWN]: prismBottom,
        },
    },
};
